import { Index } from "dwv";

const thumbCache = new Map();

function cacheKey(fileUrl, frame, w, h) {
  return `${fileUrl ?? "local"}:${frame}:${w}x${h}`;
}

/**
 * Render one frame from a loaded DWV ViewController into a JPEG data URL.
 */
export function generateFrameThumbnail(vc, scrollDim, frameIndex, thumbW = 112, thumbH = 84) {
  if (!vc) return null;

  const idx = vc.getCurrentIndex();
  const values = idx.getValues().slice();
  values[scrollDim] = frameIndex;
  const frameIdx = new Index(values);

  const size = vc.getImageSize();
  const w = size.get(0);
  const h = size.get(1);
  if (!w || !h) return null;

  const imageData = new ImageData(w, h);
  vc.generateImageData(imageData, frameIdx);

  const srcCanvas = document.createElement("canvas");
  srcCanvas.width = w;
  srcCanvas.height = h;
  srcCanvas.getContext("2d")?.putImageData(imageData, 0, 0);

  const canvas = document.createElement("canvas");
  canvas.width = thumbW;
  canvas.height = thumbH;
  const ctx = canvas.getContext("2d");
  if (!ctx) return null;

  ctx.fillStyle = "#000";
  ctx.fillRect(0, 0, thumbW, thumbH);

  const scale = Math.min(thumbW / w, thumbH / h);
  const dw = w * scale;
  const dh = h * scale;
  const dx = (thumbW - dw) / 2;
  const dy = (thumbH - dh) / 2;
  ctx.drawImage(srcCanvas, 0, 0, w, h, dx, dy, dw, dh);

  return canvas.toDataURL("image/jpeg", 0.82);
}

export async function getCachedFrameThumbnail({
  vc,
  scrollDim,
  frameIndex,
  fileUrl,
  thumbW = 112,
  thumbH = 84,
}) {
  const key = cacheKey(fileUrl, frameIndex, thumbW, thumbH);
  if (thumbCache.has(key)) return thumbCache.get(key);

  const dataUrl = generateFrameThumbnail(vc, scrollDim, frameIndex, thumbW, thumbH);
  if (!dataUrl) throw new Error("thumbnail generation failed");

  thumbCache.set(key, dataUrl);
  return dataUrl;
}

export function clearFrameThumbnailCache(fileUrl) {
  if (!fileUrl) {
    thumbCache.clear();
    return;
  }
  const prefix = `${fileUrl}:`;
  for (const key of thumbCache.keys()) {
    if (key.startsWith(prefix)) thumbCache.delete(key);
  }
}
